import { render } from "./confirma.vue?vue&type=template&id=43b31c96"
import script from "./confirma.vue?vue&type=script&lang=js"
export * from "./confirma.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__